// @import dependencies
import React, {Component, CSSProperties} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {QuestionselectrangeModuleLayout} from 'app_components/modules/questions/questionselectrange'
// @end

// @import events
// @end

// @import utils
import { getColorFromCSS } from 'app_utils/functions/getTheme'
import { I18nUtil } from 'app_utils/i18n'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import services
import storeService from 'app_services/storeService'
// @end

// @import types
// @end

// @ADD Component types
interface IQuestionselectrangeModuleProps {
  questionData: any
  attemptInformation: any
  className?: string
  style?: CSSProperties
  hideButtons?: boolean
  disabled?: boolean
  showCorrect?: boolean
  showMyResponse?: boolean
  validateMyResponse?: boolean
  showFeedback?: boolean
  onSendAnswer: (data: any) => void
  onChange?: (answer: string, question?: string)=>any
}
interface IQuestionselectrangeModuleState {
  defaultAnswer: string | null
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class QuestionselectrangeModule extends Component<IQuestionselectrangeModuleProps, IQuestionselectrangeModuleState> {

  private screenNotification: ScreenNotificationsUtil = new ScreenNotificationsUtil()
  private i18nUtil: I18nUtil = new I18nUtil()

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IQuestionselectrangeModuleProps) {
    super(props)
    this.state = {
      defaultAnswer: null,
    }

    this.onNextQuestion = this.onNextQuestion.bind(this)
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  onNextQuestion = async (data: any) => {
    // let confirmation: any = {
    //   isConfirmed: true,
    // }
    // if (data.answer === '') {
    //   confirmation = await this.screenNotification.fire(
    //     {
    //       message: `${this.i18nUtil.getTranslate('resources.questions.empty')}`,
    //     },
    //     {
    //       type: 'warning',
    //       title: `${this.i18nUtil.getTranslate('resources.questions.send_question')}`,
    //       confirmButtonText: `${this.i18nUtil.getTranslate('screenNotification.buttons.continue')}`,
    //       confirmButtonColor: getColorFromCSS('--primary'),
    //       cancelButtonText: `${this.i18nUtil.getTranslate('screenNotification.buttons.cancel')}`,
    //       showCancelButton: true,
    //     },
    //   )
    // }

    // if (confirmation.isConfirmed) {
    //   const dataForResults = {
    //     answer: data.answer,
    //     question: this.props.questionData._id,
    //   }
    //   this.props.onSendAnswer(dataForResults)
    // }
  }

  getAttemptAnswer = (attempt: any, questionId: string) => {
    let answer: string | null = null
    attempt?.statistics?.map((asn: any) => {
      if (asn.question === questionId) {
        answer = asn.answer
      }
    })

    if (!answer) {
      answer = '0'
    }

    this.setState({
      defaultAnswer: answer,
    })
    return answer
  }

  /**
   * @INFO Enviar el evento on change de la pregunta
  */
  public handleSendOnChange = (qualification: number) => {
    if(this.props.onChange && qualification){
      this.props.onChange(qualification.toString(), this.props.questionData._id)
    }
  }

  public getDefaultAnswer = (_question: any) => {
    const result = this.getAttemptAnswer(this.props.attemptInformation, _question._id)
    return result
  }

  render() {
    return(
      <QuestionselectrangeModuleLayout
        {...this.props}
        defaultAnswer={this.state.defaultAnswer}
        onNextQuestion={this.onNextQuestion}
        handleSendOnChange={this.handleSendOnChange}
        getDefaultAnswer={this.getDefaultAnswer}
      />
    )
  }
}

export default connect(mapStatesToProps)(QuestionselectrangeModule)
